var _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8067 9.5H7.19327C6.49478 9.5 5.88874 9.98211 5.73168 10.6627L3.42399 20.6627C3.20708 21.6026 3.92095 22.5 4.88558 22.5H19.1144C20.0791 22.5 20.7929 21.6026 20.576 20.6627L18.2683 10.6627C18.1113 9.98211 17.5052 9.5 16.8067 9.5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5.73438,
    r: 2.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 5.73438,
    r: 3.75
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7485 14.6276C10.6795 14.6276 10.6289 14.6069 10.5967 14.5655C10.5645 14.5241 10.5485 14.4805 10.5485 14.4345C10.5485 14.3839 10.5645 14.3379 10.5967 14.2966C10.6289 14.2552 10.6795 14.2345 10.7485 14.2345H13.2657C13.3301 14.2345 13.3783 14.2552 13.4105 14.2966C13.4427 14.3379 13.4588 14.3839 13.4588 14.4345C13.4588 14.4805 13.4404 14.5241 13.4036 14.5655C13.3714 14.6069 13.3255 14.6276 13.2657 14.6276H12.245V17.7724C12.245 17.8782 12.199 17.9494 12.1071 17.9862C12.0795 17.9954 12.0427 18 11.9967 18C11.9508 18 11.9025 17.9816 11.8519 17.9448C11.8013 17.908 11.776 17.8506 11.776 17.7724V14.6276H10.7485Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTon);
export default __webpack_public_path__ + "static/media/Ton.7080e84aac8bb21ffb1bffcbec8b1c9a.svg";
export { ForwardRef as ReactComponent };